import { render, staticRenderFns } from "./SettingSpecialSkill.vue?vue&type=template&id=7c2763ef&scoped=true&"
import script from "./SettingSpecialSkill.vue?vue&type=script&lang=js&"
export * from "./SettingSpecialSkill.vue?vue&type=script&lang=js&"
import style0 from "./SettingSpecialSkill.vue?vue&type=style&index=0&id=7c2763ef&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c2763ef",
  null
  
)

export default component.exports